<onyx-icon
  [class]="color()"
  name="semi-trailer-loaded-filled"
  [size]="size()"
  [onyxTooltip]="tooltip()"
></onyx-icon>
